import { RoleName } from "consts/auth";
import useActions from "./useActions";
import { whereUserRole } from "./helpers";

export const useHighRiskActions = () => {
    const actions = useActions();

    const withHighRiskApplications = whereUserRole(RoleName.OnboardingO);

    const getApplications = (query?: string) => actions.getApplications(
        withHighRiskApplications(query)
    );

    const downloadCsv = (query?: string) => actions.downloadCsv(
        withHighRiskApplications(query)
    );

    return {
        getApplications,
        downloadCsv
    };
};

export default useHighRiskActions;
